'use client';
import { makeStyles } from "@griffel/react";
import { typographyStyles } from "@fluentui/react-theme";
export const caption2StrongClassNames = {
    root: 'fui-Caption2Strong'
};
/**
 * Styles for the root slot
 */ export const useCaption2StrongStyles = makeStyles({
    root: typographyStyles.caption2Strong
});
